import { createSlotRecipe } from './runtime.mjs';

const overlayAnnouncementConfig = {"name":"overlayAnnouncement","className":"wd-overlay-announcement","slots":["root","contentRow","thumbnailWrapper","textColumn","eyebrowRow","eyebrowLabel","title","actionWrapper","closeButton"]}

export const overlayAnnouncement = /* @__PURE__ */ createSlotRecipe(overlayAnnouncementConfig)